import React from "react";
import ContactStyle from "../../style/body/Contact.module.css";
import IconShow from "../helperComponents/Icon";

const Contact = () => {
  return (
    <div className={`${ContactStyle.contact_page}`}>
      <div className={`${ContactStyle.elements}`}>
        <div className={`${ContactStyle.contact}`}>Contact</div>
        <p className={`${ContactStyle.opportunity}`}>
          I'm interested collaborating in the fields of blockchain and software
          engineering. Currently, I'm seeking supervision for postgraduation
          opportunities to further explore these domains.
        </p>
        <p className={`${ContactStyle.chat}`}>
          If my work resonates with you, I'd be delighted to engage in a chat.
        </p>
        <div className={`${ContactStyle.reach_out}`}>
          Please feel free to reach out{" "}
        </div>
        <div className={`${ContactStyle.mail}`}>azammoshiul8@gmail.com</div>
        <div>
          <IconShow
            path="mailto:azammoshiul8@gmail.com"
            className={`${ContactStyle.side_icon}`}
            src="assets/icons/contact-icons/email.svg"
          />
          <IconShow
            path="tel:+880 1631925038"
            className={`${ContactStyle.side_icon}`}
            src="assets/icons/contact-icons/whatsapp.svg"
          />
          <IconShow
            path="https://bd.linkedin.com/in/moshiulazamm"
            className={`${ContactStyle.side_icon}`}
            src="assets/icons/contact-icons/linkedin.svg"
          />
          <IconShow
            path="https://scholar.google.com/citations?hl=en&user=aMUcKlsAAAAJ"
            className={`${ContactStyle.side_icon}`}
            src="assets/icons/contact-icons/scholar.svg"
          />
          <IconShow
            path="https://www.researchgate.net/profile/Md-Azam-28"
            className={`${ContactStyle.side_icon}`}
            src="assets/icons/contact-icons/researchgate.svg"
          />
          <IconShow
            path="https://github.com/moshiul45"
            className={`${ContactStyle.side_icon}`}
            src="assets/icons/contact-icons/github.svg"
          />
          <IconShow
            path="https://stackoverflow.com/users/19968600/azam45"
            className={`${ContactStyle.side_icon}`}
            src="assets/icons/contact-icons/stackoverflow.svg"
          />
          <IconShow
            path="https://www.stopstalk.com/user/profile/azam45"
            className={`${ContactStyle.side_icon}`}
            src="assets/icons/contact-icons/stopstalk.svg"
          />
        </div>
      </div>
    </div>
  );
};

export default Contact;
